webpackJsonp([212839066777427],{

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(27);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(30);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(29);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(85);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(19);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 1234:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(1281);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _TagList = __webpack_require__(161);
	
	var _TagList2 = _interopRequireDefault(_TagList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogCard = function BlogCard(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: props.classes.root },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: "/" + props.slug + "/" },
	      props.image ? _react2.default.createElement(_gatsbyImage2.default, {
	        className: props.classes.postImage,
	        sizes: props.image.sizes,
	        backgroundColor: "#eeeeee"
	      }) : null,
	      _react2.default.createElement(
	        "div",
	        { className: props.classes.postTitle },
	        props.title
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: props.classes.postDate },
	        props.date
	      ),
	      _react2.default.createElement("div", {
	        className: props.classes.postDesc,
	        dangerouslySetInnerHTML: {
	          __html: props.excerpt.childMarkdownRemark.excerpt
	        }
	      }),
	      props.tags && _react2.default.createElement(_TagList2.default, { tags: props.tags })
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    "@global body": {
	      backgroundColor: "#fff !important",
	      a: {
	        textDecoration: "none !important",
	        "&:hover": {
	          textDecoration: "none !important"
	        }
	      }
	    },
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "280px",
	      background: "#fff", // material-design 1dp
	      transition: "all 200ms ease-in-out",
	      overflow: "hidden",
	      userSelect: "none",
	      borderRadius: "3px"
	      // boxShadow: "0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12)", // material-design 8dp
	    },
	    link: {
	      color: "inherit !important", // remove default `a` tag styling, along with :hover/:active/:etc.
	      textDecoration: "inherit !important" // remove default `a` tag styling, along with :hover/:active/:etc.
	    },
	    postImage: {
	      marginBottom: "5px",
	      width: "280px",
	      height: "220px",
	      backgroundSize: "cover",
	      backgroundPosition: "center center"
	    },
	    postDate: {
	      marginBottom: "6px",
	      fontSize: "12px",
	      color: "#504E62"
	    },
	    postTitle: {
	      fontSize: "20px",
	      fontWeight: "800",
	      lineHeight: "28px",
	      color: "#2E2E35",
	      marginBottom: "4px",
	
	      a: {
	        textDecoration: "none",
	        "&:hover": {
	          textDecoration: "none !important"
	        }
	      }
	    },
	    postDesc: {
	      display: "flex",
	      lineHeight: "21px",
	      marginBottom: "8px",
	      fontSize: ".875rem",
	      color: "#504E62"
	    },
	    postTagsContainer: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "center",
	      marginBottom: "30px"
	    },
	    postTags: {
	      marginRight: "6px",
	      marginBottom: "4px",
	      fontSize: "10px",
	      fontWeight: "800",
	      color: "#A9A8B6",
	      letterSpacing: ".5px",
	      padding: "8px",
	      borderRadius: "16px",
	      backgroundColor: "#ECECEC",
	      "&:hover": {
	        color: "#A9A8B6",
	        textDecoration: "none !important"
	      }
	    },
	    postTagLink: {
	      "&:hover": {
	        textDecoration: "none !important"
	      }
	    },
	    postPlusMore: {
	      marginRight: "6px",
	      marginLeft: "6px",
	      paddingTop: "6px",
	      fontSize: "12px",
	      fontWeight: "700",
	      color: "#A9A8B6",
	      letterSpacing: ".5px",
	      paddingBottom: "8px",
	      display: "block"
	    },
	    postReadMore: {
	      textTransform: "uppercase",
	      letterSpacing: ".5px",
	      color: "#2E2E35",
	      fontSize: "14px",
	      display: "flex",
	      alignItems: "center"
	    }
	  };
	})(BlogCard);
	module.exports = exports["default"];

/***/ }),

/***/ 1235:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogCardGrid = function BlogCardGrid(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className) },
	    children
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _root;
	
	  return {
	    "@global": {
	      body: {
	        backgroundColor: "#fff !important"
	      },
	      a: {
	        textDecoration: "none !important",
	        "&:hover": {
	          textDecoration: "none !important"
	        }
	      }
	    },
	    root: (_root = {
	      display: "grid",
	      gridTemplateColumns: "280px",
	      gridColumnGap: "24px",
	      gridRowGap: "60px",
	      justifyContent: "center",
	      width: "100%",
	      margin: "48px auto 96px auto"
	
	    }, _root[theme.breakpoints[600]] = {
	      gridTemplateColumns: "repeat(2, 280px)"
	    }, _root[theme.breakpoints[900]] = {
	      gridTemplateColumns: "repeat(3, 280px)"
	    }, _root)
	  };
	})(BlogCardGrid);
	module.exports = exports["default"];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTitle = function PageTitle(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className) },
	    children
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _root;
	
	  return {
	    root: (_root = {
	      width: "100%",
	      lineHeight: "1.2",
	      fontSize: "28px",
	      color: "#2E2E35",
	      fontWeight: "800",
	      marginBottom: "32px"
	
	    }, _root[theme.breakpoints[600]] = {
	      fontSize: "36px"
	    }, _root)
	  };
	})(PageTitle);
	module.exports = exports["default"];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagList = function TagList(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: props.classes.postTagsContainer },
	    props.tags.map(function (tag) {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          key: tag.id,
	          className: props.classes.postTagLink,
	          to: "/tag/" + tag.slug + "/"
	        },
	        tag.title
	      );
	    })
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _postTagsContainer;
	
	  return {
	    postTags: {},
	    postTagLink: {
	      fontSize: "10px",
	      lineHeight: "16px",
	      fontWeight: "800",
	      letterSpacing: ".5px",
	      textAlign: "center",
	      textDecoration: "none",
	      marginRight: "4px",
	      color: "#A9A8B6",
	      backgroundColor: "#ECECEC",
	      padding: "6px 12px",
	      borderRadius: "14px",
	
	      "&:hover": {
	        textDecoration: "none",
	        color: "#A9A8B6",
	        backgroundColor: "#dfdfdf"
	      }
	    },
	    postTagsContainer: (_postTagsContainer = {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "center",
	      padding: "20px 8px"
	
	    }, _postTagsContainer[theme.breakpoints[600]] = {
	      padding: "20px 0"
	    }, _postTagsContainer)
	  };
	})(TagList);
	module.exports = exports["default"];

/***/ }),

/***/ 1652:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _BlogCardGrid = __webpack_require__(1235);
	
	var _BlogCardGrid2 = _interopRequireDefault(_BlogCardGrid);
	
	var _BlogCard = __webpack_require__(1234);
	
	var _BlogCard2 = _interopRequireDefault(_BlogCard);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _PageTitle = __webpack_require__(159);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Blog = function (_Component) {
	  _inherits(Blog, _Component);
	
	  function Blog(props) {
	    _classCallCheck(this, Blog);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleLoadPosts = function () {
	      _this.setState(function (state) {
	        return {
	          availablePosts: state.availablePosts + 6
	        };
	      });
	    };
	
	    _this.state = {
	      availablePosts: 6
	    };
	    return _this;
	  }
	
	  Blog.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        tags = _props.tags,
	        data = _props.data;
	    var availablePosts = this.state.availablePosts;
	
	    var posts = data.allContentfulPost.edges;
	    return _react2.default.createElement(
	      "div",
	      { className: classes.root },
	      _react2.default.createElement(_SEO2.default, null),
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          _PageTitle2.default,
	          { className: classes.title },
	          "The Elevate Blog"
	        ),
	        _react2.default.createElement(
	          _BlogCardGrid2.default,
	          null,
	          posts.slice(0, availablePosts).map(function (_ref) {
	            var post = _ref.node;
	            return _react2.default.createElement(_BlogCard2.default, {
	              tags: tags,
	              key: post.id,
	              slug: post.slug,
	              image: post.heroImage,
	              title: post.title,
	              date: post.publishDate,
	              excerpt: post.body
	            });
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.btnContainer },
	          posts.length >= availablePosts ? _react2.default.createElement(
	            "button",
	            { className: classes.btn, onClick: this.handleLoadPosts },
	            "Load more posts"
	          ) : null
	        )
	      )
	    );
	  };
	
	  return Blog;
	}(_react.Component);
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      padding: "0 8px",
	      margin: "72px auto 96px auto"
	    },
	    title: {
	      display: "flex",
	      justifyContent: "center",
	      width: "100%"
	    },
	    btnContainer: {
	      display: "flex",
	      justifyContent: "center",
	      maxWidth: "100%"
	    },
	    btn: {
	      color: "#EF5A57",
	      fontWeight: "600",
	      padding: "16px 80px",
	      border: "2px solid #EF5A57",
	      borderRadius: "8px"
	    }
	  };
	})(Blog);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-2cf378b20ba4eb05328c.js